const stats = [
  {
    icon: 'fa-star',
    value: '5.0',
    unit: '★',
    label: 'Google Rating',
    detail: 'Perfect 5-Star Score',
  },
  {
    icon: 'fa-calendar-check',
    value: '20+',
    unit: '',
    label: 'Years Experience',
    detail: 'Since Early 2000s',
  },
  {
    icon: 'fa-hammer',
    value: '500+',
    unit: '',
    label: 'Installs Completed',
    detail: 'Across Camden County',
  },
  {
    icon: 'fa-shield-halved',
    value: '100%',
    unit: '',
    label: 'Licensed & Insured',
    detail: 'Georgia Certified',
  },
];

const TrustBar: React.FC = () => (
  <section className="relative z-20 bg-[#0D0C0B] border-b border-[#C4A84F]/15 -mt-1">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-2 lg:grid-cols-4">
        {stats.map((s, i) => (
          <div
            key={s.label}
            className={`group relative flex items-center gap-5 py-9 px-7 cursor-default select-none ${
              i < stats.length - 1 ? 'border-r border-[#C4A84F]/10' : ''
            } hover:bg-[#C4A84F]/6 transition-colors duration-400`}
          >
            {/* Left gold accent on hover */}
            <div className="absolute left-0 top-1/4 bottom-1/4 w-[2px] bg-[#C4A84F] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            {/* Icon */}
            <div className="shrink-0 w-13 h-13 w-12 h-12 flex items-center justify-center border border-[#C4A84F]/25 group-hover:border-[#C4A84F] group-hover:bg-[#C4A84F]/12 transition-all duration-400">
              <i className={`fa-solid ${s.icon} text-[#C4A84F] text-base`} />
            </div>

            {/* Text */}
            <div>
              <div className="flex items-baseline gap-1">
                <span className="font-serif text-2xl text-[#F5F1E8] leading-none">{s.value}</span>
                {s.unit && <span className="text-[#C4A84F] font-serif text-lg">{s.unit}</span>}
              </div>
              <div className="text-[10px] text-[#F5F1E8]/38 tracking-[0.22em] uppercase font-sans mt-1.5">
                {s.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="gold-separator" />
  </section>
);

export default TrustBar;
